import { render, staticRenderFns } from "./dictbiz.vue?vue&type=template&id=66ce24f9&"
import script from "./dictbiz.vue?vue&type=script&lang=js&"
export * from "./dictbiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports